import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";


import { placeholderImage } from "../../Assets/images";
import BackButton from "../../Components/BackButton";
import CustomModal from "../../Components/CustomModal";
import CustomTextModal from "../../Components/CustomTextModal";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from "../../Components/Loader";
import UseTableControls from "../../Config/UseTableControls";
import { useGetUsersQuery, useUpdateUserMutation } from "../../Redux/Apis/User";

const UserRequestDetails = () => {

  const { id } = useParams();
  const navigate = useNavigate()

  const { data, isLoading, refetch } = useGetUsersQuery({ id });
  const [changeUserStatus, { isLoading: isUpdating }] = useUpdateUserMutation();

  const [reason, setReason] = useState("")

  if (data) {
    var { data: profileData } = data
  }

  UseTableControls();

  const [modal, setModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);

  const toggle = () => { setModal(!modal) }

  const approveUser = () => {
    changeUserStatus({ id: profileData?._id, payload: { status: "Approved" } }).then((res) => {
      if (!res?.error) {
        setShowModal(false)
        setShowModal2(true)
      } else {
        setShowModal(false)
      }
    })
  }

  const rejectUser = () => {
    changeUserStatus({ id: profileData?._id, payload: { status: "Rejected", reason } }).then((res) => {
      if (!res?.error) {
        setShowModal3(false)
        setShowModal4(true)
      } else {
        setShowModal3(false)
      }
    })
  }

  useEffect(() => {
    document.title = 'The Turn At | Details';
  }, [])


  return (
    <>
      <DashboardLayout>
        <div className="dashCard mb-4">
          <div className="row mb-3">
            <div className="col-12 mb-2">
              <h2 className="mainTitle">
                <BackButton />
                User Details
              </h2>
            </div>
          </div>
          <div className="row mb-3">
            {
              isLoading ? <Loader /> :
                <div className="col-12">
                  <div className="row mb-3 justify-content-between">
                    <div className="col-lg-4  order-2 order-lg-1 mb-3">
                      <div className="profileImage">
                        <img src={profileData?.picture ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${profileData?.picture}` : placeholderImage} alt="User" />
                      </div>
                    </div>
                    <div className="col-lg-4 text-end order-1 order-lg-2 mb-3">
                      <button onClick={() => {
                        setShowModal(true)
                      }} className="notButton primaryColor fw-bold text-decoration-underline">Approve</button>
                      <button onClick={toggle} className="notButton text-danger fw-bold text-decoration-underline">Reject</button>
                      <span className={`statusBadge bg-warning`}>{profileData?.business}</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="row">
                        <div className="col-xl-6 col-md-6 mb-3">
                          <h4 className="secondaryLabel">Name</h4>
                          <p className="secondaryText">{profileData.fullName}</p>
                        </div>
                        <div className="col-xl-6 col-md-6 mb-3">
                          <h4 className="secondaryLabel">Email Address</h4>
                          <p className="secondaryText">{profileData.email}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="row mb-3">
                        <label className="mainTitle">Businesses</label>
                      </div>
                      {
                        profileData?.businesses?.map((item, index) => (
                          <div className="row m-1 p-2">
                            <div className="row mb-3">
                              <div className="col-12 mb-2">
                                <h2 className="mainTitle">
                                  <b>User Business {index + 1}</b>
                                </h2>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 col-md-6 mb-3">
                                <h4 className="secondaryLabel">Business Name</h4>
                                <p className="secondaryText">{item?.name}</p>
                              </div>
                              <div className="col-xl-6 col-md-6 mb-3">
                                <h4 className="secondaryLabel">Business Type</h4>
                                <p className="secondaryText">{item?.type}</p>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-12 col-md-12 mb-3">
                                <h4 className="secondaryLabel">Business Address Line 1</h4>
                                <p className="secondaryText">{item?.address_1}</p>
                              </div>
                            </div>
                            {
                              item?.address_2 && item?.address_2 !== "" &&
                              <div className="row">
                                <div className="col-xl-12 col-md-12 mb-3">
                                  <h4 className="secondaryLabel">Business Address Line 2</h4>
                                  <p className="secondaryText">{item?.address_2}</p>
                                </div>
                              </div>
                            }
                            <div className="row">
                              <div className="col-xl-4 col-md-4 mb-3">
                                <h4 className="secondaryLabel">City</h4>
                                <p className="secondaryText">{item?.city}</p>
                              </div>
                              <div className="col-xl-4 col-md-4 mb-3">
                                <h4 className="secondaryLabel">State</h4>
                                <p className="secondaryText">{item?.state}</p>
                              </div>
                              <div className="col-xl-4 col-md-4 mb-3">
                                <h4 className="secondaryLabel">Postal Code</h4>
                                <p className="secondaryText">{item?.postalcode}</p>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 col-md-6 mb-3">
                                <h4 className="secondaryLabel mb-3">Business License</h4>
                                <img src={`${process.env.REACT_APP_IMAGE_ENDPOINT}${item?.businessLicense}`} style={{ width: "200px", height: "200px", objectFit: 'contain' }} />
                              </div>
                              <div className="col-xl-6 col-md-6 mb-3">
                                <h4 className="secondaryLabel mb-3">Vape License</h4>
                                <img src={`${process.env.REACT_APP_IMAGE_ENDPOINT}${item?.vapeLicense}`} style={{ width: "200px", height: "200px", objectFit: 'contain' }} />
                              </div>
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
            }
          </div>
        </div>

        <CustomModal loading={isUpdating} show={showModal} close={() => { setShowModal(false) }} action={approveUser} heading='Are you sure you want to mark approve?' />
        <CustomModal show={showModal2} close={() => { setShowModal2(false), navigate("/vendor-requests") }} success heading='Marked as Approved' />

        <CustomModal loading={isUpdating} show={showModal3} close={() => { setShowModal3(false) }} action={rejectUser} heading='Are you sure you want to mark rejected?' />
        <CustomModal show={showModal4} close={() => { setShowModal4(false), navigate("/vendor-requests") }} success heading='Marked as Rejected' />

        <CustomTextModal
          show={modal}
          close={toggle}
          heading="Rejection Reason"
          action={rejectUser}
          textboxes={[
            {
              label: "Reason",
              placeholder: "Enter Reason",
              type: "text",
              value: reason,
              onChange: (e) => setReason(e.target.value)
            }
          ]}
          loading={isUpdating}
        />

      </DashboardLayout>
    </>
  );
};

export default UserRequestDetails;
